import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@arcadeai/design-system/components/ui/atoms/sidebar";
import { useNavigate } from "@tanstack/react-router";
import { Sparkles } from "lucide-react";
import { useOrgProjectRouteContext } from "@/lib/org-project-context/hooks";

function CtaCardContent() {
  return (
    <div className="w-full min-w-0 flex-1 rounded-md bg-gradient-to-r from-violet-400/10 via-blue-500/10 to-cyan-400/10 p-2">
      <div className="flex items-center gap-2">
        <Sparkles className="size-4 text-black dark:text-white" />
        <p className="font-semibold text-black dark:text-white">
          Complete Onboarding
        </p>
      </div>
      <p className="mt-1 text-muted-foreground text-xs">
        Finish setup to make your first tool call.
      </p>
    </div>
  );
}

export function OnboardingCtaButton() {
  const { state } = useSidebar();
  const { organizationId, projectId } = useOrgProjectRouteContext();
  const navigate = useNavigate();

  return (
    <SidebarMenu>
      <SidebarMenuItem
        className="my-3"
        onClick={() => {
          navigate({
            to: "/orgs/$organizationId/projects/$projectId/onboarding",
            params: { organizationId, projectId },
          });
        }}
      >
        <SidebarMenuButton
          className="mb-2 h-auto w-full cursor-pointer rounded-md p-0 hover:bg-muted/50 active:bg-muted/90"
          tooltip="Complete Onboarding"
        >
          {state === "collapsed" ? (
            <Sparkles className="size-4" />
          ) : (
            <CtaCardContent />
          )}
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
